import AlertsEmpty from './alerts-empty';

export default AlertsEmpty;
